import { SET_IS_GRID } from '../actionTypes'

export const setIsGrid = (isGrid: boolean) => ({
  type: SET_IS_GRID,
  payload: isGrid,
})
